export const scrollbarWidth = () => {
  //スクロールバーのwidthを取得、設定。
  function observeScrollbarWidth() {
    const scrollBarWidth =
      window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty(
      "--scrollbar-width",
      `${scrollBarWidth}px`
    );
  }

  window.addEventListener("load", observeScrollbarWidth);
  window.addEventListener("resize", observeScrollbarWidth);
};
